<template>
  <div class="d-flex">
    <div
      v-if="thumbnail"
      class="thumbnail-upload-file">
      <img
        :src="thumbnail"
        width="25">
    </div>
    <div
      v-else
      class="thumbnail-upload-file">
      <img
        :src="imgDefaultThumbnail"
        width="25">
    </div>

    <b-form-file
      ref="fileinput"
      v-model="file"
      plain/>
    <div
      v-if="thumbnail"
      class="info-upload-file">
      {{ fileName }} <br>
      <span
        v-if="!disabled"
        class="label-change-file-upload-file"
        @click="clickBrowseButton">Change File</span>
      <span
        class="label-download-upload-file"
        @click="clickedPreviewCard">Download</span>
    </div>
    <div
      v-else
      class="upload-file"
      @click="clickBrowseButton">
      Upload File
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars,import/no-unresolved,vue/require-default-prop,global-require,max-len,no-underscore-dangle */

import { mapActions } from 'vuex';
import axios from 'axios';

export default {
  props: {
    acceptedFileType: {
      type: Array,
      default: () => ([]),
    },
    label: {
      type: String,
      default: 'Browse',
    },
    imgDefault: {
      type: String,
      default: null,
    },
    nameDefault: {
      type: String,
      default: '',
    },
    apiToken: {
      type: String,
      default: '',
    },
    urlUpload: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maxFileSize: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      file: null,
      fileName: this.nameDefault ? this.nameDefault : '-',
      thumbnail: null,
      fileUrl: this.imgDefault ? this.imgDefault : '',
      fileType: '',
      fileSize: '',
      error_message: '',
    };
  },
  computed: {
    imgDefaultThumbnail() {
      const fileThumbnail = require('./file.png');
      return fileThumbnail;
    },
  },
  watch: {
    fileUrl() {
      this.$emit('url', this.fileUrl);
    },
    file() {
      if (this.file !== null && this.file !== undefined) {
        const fileName = this.file.name;
        const fileSize = this.file.size;
        const dotPosition = fileName.lastIndexOf('.') + 1;
        let extension = fileName.substring(dotPosition);
        extension = extension.toLowerCase();
        this.fileType = extension;

        let isAccepted = false;
        this.acceptedFileType.forEach((type) => {
          if (type === extension) {
            isAccepted = true;
          }
        });

        let isSizeAccepted = false;
        if (this.maxFileSize) {
          if (fileSize < this.maxFileSize * 1000) {
            isSizeAccepted = true;
          }
        } else {
          isSizeAccepted = true;
        }

        if (isAccepted && isSizeAccepted) {
          this.uploadFile(this.file, extension);
          this.fileName = fileName;
          this.fileSize = fileSize;
        } else {
          if (!isAccepted) {
            this.error_message = 'Please choose a wanted file!';
            this.clearFiles();
            this.$refs.problemScreen.toggleProblemScreen();
          }
          if (!isSizeAccepted) {
            this.error_message = `Please upload a file less than ${this.maxFileSize / 1000}MB!`;
            this.clearFiles();
            this.$refs.problemScreen.toggleProblemScreen();
          }
          if (!isSizeAccepted && !isAccepted) {
            this.error_message = 'Please choose a wanted file!';
            this.clearFiles();
            this.$refs.problemScreen.toggleProblemScreen();
          }
        }
      }
    },
    imgDefault(val) {
      const fileName = val;
      const dotPosition = fileName.lastIndexOf('.') + 1;
      let extension = fileName.substring(dotPosition);
      extension = extension.toLowerCase();
      const thumbnail = this.determineThumbnails(extension);
      this.thumbnail = thumbnail;
    },
  },
  created() {
    if (this.imgDefault) {
      const fileName = this.imgDefault;
      const dotPosition = fileName.lastIndexOf('.') + 1;
      let extension = fileName.substring(dotPosition);
      extension = extension.toLowerCase();
      const thumbnail = this.determineThumbnails(extension);
      this.thumbnail = thumbnail;
    }
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem', 'toggleSuccess']),

    clearFiles() {
      this.fileUrl = '';
      this.$refs.fileinput.reset();
    },
    determineThumbnails(extension) {
      const pdfThumbnail = require('./pdf.png');
      const fileThumbnail = require('./file.png');
      //   const docThumbnail = require('./doc.svg');
      //   const xlsThumbnail = require('./xls.svg');
      //   const csvThumbnail = require('./csv.svg');
      //   const txtThumbnail = require('./txt.svg');

      if (extension === 'pdf') {
        return pdfThumbnail;
      }
      //   if (extension === 'doc' || extension === 'docx' || extension === 'ppt' || extension === 'pptx') {
      //     return docThumbnail;
      //   } if (extension === 'xls' || extension === 'xlsx') {
      //     return xlsThumbnail;
      //   } if (extension === 'csv') {
      //     return csvThumbnail;
      //   } if (extension === 'txt') {
      //     return txtThumbnail;
      //   }
      return fileThumbnail;
    },
    deleteFile() {
      this.file = null;
      this.fileName = '';
      this.thumbnail = '';
      this.fileUrl = '';
      this.fileType = '';
      this.imgDefault = null;
      this.clearFiles();
    },
    clickedPreviewCard() {
      window.open(this.fileUrl, '_blank');
    },
    clickBrowseButton() {
      if (!this.disabled) {
        this.$refs.fileinput.$refs.input.click();
      }
    },
    uploadFailed() {
      this.file = null;
      this.fileUrl = '';
    },
    uploadSuccess(thumbnail, fileUrl) {
      this.thumbnail = thumbnail;
      this.fileUrl = fileUrl;
    },

    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    async uploadFile(file, extension) {
      const thumbnail = this.determineThumbnails(extension);
      this.showLoading();
      const apiKey = this.apiToken;
      const imagebase = await this.getBase64(file).then(
        data => data,
      );
      const commaPosition = imagebase.lastIndexOf(',') + 1;
      const imageData = imagebase.substring(commaPosition);
      const fileName = file.name;
      let sendData = {};

      sendData = {
        filename: fileName,
        content: imageData,
      };

      axios.post(this.urlUpload, sendData, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: apiKey,
        },
      }).then((res) => {
        const data = res.data.data;
        const imageUrl = data.url;
        if (thumbnail === '') {
          this.uploadSuccess(imageUrl, imageUrl);
        } else {
          this.uploadSuccess(thumbnail, imageUrl);
        }
        this.hideLoading();
        this.toggleSuccess(res.data.message);
      }).catch((error) => {
        this.error_message = error.response.data.message;
        this.hideLoading();
        this.toggleProblem(this.error_message);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/upload-file/jUploadFile.vue